import React from 'react'

export default function PaddingTop({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M3 13V10C3 8.89543 3.89543 8 5 8H15C16.1046 8 17 8.89543 17 10V13'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
            />
            <path d='M7 11H13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
